<template>
<div>
  <columns>
    <column>
      <h4 class="is-size-5">Software</h4>
    </column>
  </columns>
  <div class="is-flex justify-between mb" v-for="software in software" :key="software.id">
    <p>
      <span class="has-text-weight-bold">{{ software.name }} </span>
      <span>{{ software.installed.version.version_number }}</span>
      <span v-if="software.unresolved_findings.length" class="tag is-danger">
        <icon icon="exclamation-triangle"/>
      </span>
    </p>
    <p>
      <!-- <span class="tag is-danger" v-if="countUnresolvedVulnerabilities(software).length">
        <span>{{ `${countUnresolvedVulnerabilities(software).length}` }}</span>
      </span>
      <span class="tag is-success" v-else>
        <icon icon="check"/>
      </span> -->
    </p>
  </div>
   
</div>  
</template>
<script>
import { mapGetters } from 'vuex'
import { find } from 'lodash'

export default {

  methods: {
    // countUnresolvedVulnerabilities(software) {
    //   return software.version.vulnerabilities.filter(vul => {
    //     let vulnerablity = find(this.unresolvedVulnerabilities, vulnerability => vulnerability.id === vul.id)
    //     return vulnerablity
    //   })
    // }
  },
  
  computed: {
    ...mapGetters('environment', [
      'software'
    ])
  }

}
</script>